export default __webpack_public_path__ + "static/media/grid_filter2.ee9533bd.svg";